import request from './request'

/**
 * 获取支付成功结果
 * @param {string} trade_no 订单号
 */
export function getPaySuccessInfo(data) {
  return request.get('/getPaySuccessInfo.php', {
    params: data
  })
}
